import { NgModule, inject } from "@angular/core";
import {MainComponent} from "./main.component";
import {RouterModule} from "@angular/router";
import {CommonModule} from "@angular/common";
import {MatRippleModule} from "@angular/material/core";
import {MatMenuModule} from "@angular/material/menu";
import {MatSelectModule} from "@angular/material/select";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {NavigationModule} from "./navigation/navigation.module";
import {LanguageManagerModule} from "../language-manager/language-manager.module";
import {NotificationModule} from "./notifications/notification.module";
import {MatButtonModule} from "@angular/material/button";
import {MatSortModule} from "@angular/material/sort";
import { AskPermissionsComponent } from './ask-permissions/ask-permissions.component';
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatDividerModule} from '@angular/material/divider';
import { MfaSetupComponent } from './account/mfa/mfa-setup/mfa-setup.component';
import { MfaNumPadComponent } from './account/mfa/mfa-num-pad/mfa-num-pad.component';
import  { Injector} from '@angular/core';
import  { createCustomElement } from '@angular/elements';
import {CtTimeIconComponent} from "./control-tower/ct-time-icon/ct-time-icon.component";
import {CookieConsentComponent} from "./cookie-consent/cookie-consent.component";
import {routes} from "./main.routes";



@NgModule({
  declarations: [
    MainComponent,
    AskPermissionsComponent,
    MfaSetupComponent,
    CookieConsentComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatRippleModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NavigationModule,
    LanguageManagerModule,
    NotificationModule,
    //DashboardModule,
    MatDividerModule,
    MatMenuModule,
    MatButtonModule,
    MatSelectModule,
    MatSortModule,
    MatCheckboxModule,
    MfaNumPadComponent
  ]
})
export class MainModule {
  private injector = inject(Injector);

  constructor() {
    const injector = this.injector;

    const el = createCustomElement(CtTimeIconComponent, { injector });
    customElements.define('app-ct-icon', el);
  }

}
